import { useEffect } from 'react';

import { useLojaStepContext } from 'pages/cadastro/loja/contexts';

export function useLojaDirty(dirty: boolean) {
    const { setActiveStepDirty } = useLojaStepContext();

    useEffect(() => {
        setActiveStepDirty(dirty);
    }, [dirty]);
}
